import RegisterError from './register-error-container';

export default RegisterError;
